var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.66,
    height: 20,
    viewBox: "0 0 23.66 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_135",
    "data-name": "Raggruppa 135",
    transform: "translate(-263.17 -24.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_130",
    "data-name": "Raggruppa 130",
    transform: "translate(65.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_129",
    "data-name": "Raggruppa 129",
    transform: "translate(7.591 9.449)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_36",
    "data-name": "Linea 36",
    x2: 13.664,
    transform: "translate(199.496 22.051)",
    fill: "none",
    stroke: "#5bd88f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_37",
    "data-name": "Linea 37",
    x2: 21.66,
    transform: "translate(191.5 16.051)",
    fill: "none",
    stroke: "#5bd88f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_39",
    "data-name": "Linea 39",
    x2: 13.33,
    transform: "translate(199.83 28.05)",
    fill: "none",
    stroke: "#5bd88f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_40",
    "data-name": "Linea 40",
    x2: 21.33,
    transform: "translate(191.83 34.051)",
    fill: "none",
    stroke: "#5bd88f",
    strokeLinecap: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Poligono_1",
    "data-name": "Poligono 1",
    d: "M3.5,0,7,6H0Z",
    transform: "translate(263.17 38) rotate(-90)",
    fill: "#5bd88f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpened);
export default __webpack_public_path__ + "static/media/menu-opened.66dc6276ae1847d6dbb1752653fd97ef.svg";
export { ForwardRef as ReactComponent };